import { render } from "./SelectFontComp.vue?vue&type=template&id=395b3070"
import script from "./SelectFontComp.vue?vue&type=script&lang=js"
export * from "./SelectFontComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__